import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { getPrefix } from "../../../../../Application/slices/models";
import ReducerNamespaceTypes from "../../../../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../../../../enums/reducer/reducerEntityPrefixTypes";

export interface CreatingSendState {
  created: boolean;
  isLoading: boolean;
  error?: string;
}

export const messageCreateSendInitialState: CreatingSendState = {
  created: false,
  isLoading: false,
  error: undefined,
};

const messageCreateSendSlice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Messages,
    name: "createSend",
  }),
  initialState: messageCreateSendInitialState,
  reducers: {
    createBegin(state: CreatingSendState) {
      state.isLoading = true;
    },
    createSuccess(state: CreatingSendState) {
      state.created = true;
      state.isLoading = false;
    },
    createFailure(state: CreatingSendState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetCreation() {
      return { ...messageCreateSendInitialState };
    },
  },
});

export const { createBegin, createSuccess, createFailure, resetCreation } = messageCreateSendSlice.actions;

export const messageCreateSendReducer = messageCreateSendSlice.reducer;
